import { api, itdrApi } from "./api";

const policyService = {
  /**
   * Build query string from filter object
   * @param {Object} filters - Filter parameters
   * @returns {string} Query string
   */
  _buildQueryString(filters = {}) {
    const params = new URLSearchParams();

    if (filters.page) params.append("page", filters.page);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.search) params.append("search", filters.search);
    if (filters.sortBy) params.append("sortBy", filters.sortBy);
    if (filters.sortOrder) params.append("sortOrder", filters.sortOrder);

    // Category filter (single or multiple)
    if (filters.category) {
      const categories = Array.isArray(filters.category)
        ? filters.category.join(",")
        : filters.category;
      params.append("category", categories);
    }

    // Status filter (active, draft, disabled)
    if (filters.status) {
      const statuses = Array.isArray(filters.status)
        ? filters.status.join(",")
        : filters.status;
      params.append("status", statuses);
    }

    // Risk Weight filter (min/max)
    if (filters.minRiskWeight)
      params.append("minRiskWeight", filters.minRiskWeight);

    if (filters.maxRiskWeight)
      params.append("maxRiskWeight", filters.maxRiskWeight);

    // Coverage filter (min/max)
    if (filters.minCoverage)
      params.append("minCoverage", filters.minCoverage);

    if (filters.maxCoverage)
      params.append("maxCoverage", filters.maxCoverage);

    // Active only shortcut
    if (filters.activeOnly)
      params.append("activeOnly", filters.activeOnly);

    const queryString = params.toString();
    return queryString ? `?${queryString}` : "";
  },


  async getAttackVectorByType(identity_type) {
    const response = await api.get(`/vectors/${identity_type}`);
    // console.log("getallpolicies",response);
    return response?.data;

  },
  async getAttackVectorUsecases(vectorId) {
    const response = await api.get(`vector/${vectorId}/usecases`);

    return response?.data;

  },

  async getMfaActivity(timePeriod = '24h') {
    const response = await api.get(`/mfa-activity?time_period=${timePeriod}`);
    return response.data;
  },

  // async getUseCaseIdentities(usecase_name,identity_type,total_identities){
  //   const response = await api.get(`usecase/${usecase_name}/${identity_type}/identities?limit=${total_identities}`);
  //   return response?.data;
  // },

  async getUseCaseIdentities(usecase_name, identity_type, page, limit, search) {
    const queryParams = {
      page: page,
      limit: limit
    };
    if (search) {
      queryParams.search = search;
    }
    const response = await api.get(`usecase/${usecase_name}/${identity_type}/identities`, { params: queryParams });
    return response?.data;
  },

  async backlogUseCaseIdentity(identityId, riskId) {
    const response = await api.put(`/flagged/backlog/${riskId}/identity/${identityId}`);
    return response?.data;
  },

  async getPolicyOverview() {
    const response = await api.get(`/policies/overview`);
    return response?.data;
  },
  async getTopAttackVectors(type) {
    const response = await api.get(`/risk/attack-overview?type=${type}`);
    return response?.data;
  },
  async getAttackVectorIdentities(vectorId, page, limit, search) {
    const queryParams = {
      page: page,
      limit: limit
    };
    if (search) {
      queryParams.search = search;
    }
    const response = await api.get(`/risk/vector/${vectorId}/identity`, { params: queryParams });
    return response?.data;
  },
  async getAuthenticationRisk(filters = {}) {
    // const queryString = this._buildQueryString(filters);
    const response = await itdrApi.get(`/metrics`);
    // console.log("itdr-matrics",response)
    return response?.data;
  },

  async getAuthRiskVectorUsers(metricName) {
    const response = await itdrApi.get(`/rules/triggers/users`, {
      params: { rule_name: metricName }
    });
    // console.log("itdr-matrics",response)
    return response?.data;
  },


};

export default policyService;